import classNames from 'classnames'
import React from 'react'

import { Theme } from '../../../../types/shared'
import { DialogBody, Popover, ZIndexContext } from '../../../components'
import { ChartEventBadgeType } from '../../../constants/common'
import { IDividends, IEarnings, ISplit } from '../utils'
import { ChartEventDividendsPopoverContent } from './dividends-popover-content'
import { ChartEventEarningsPopoverContent } from './earnings-popover-content'
import { ChartEventSplitPopoverContent } from './split-popover-content'

interface INoteDialog {
  id?: string
  popoverState: any
  badgeType: ChartEventBadgeType
  data: ISplit | IDividends | IEarnings
  theme: Theme
}

function getChartEventContentComponent(
  badgeType: ChartEventBadgeType,
  data: ISplit | IDividends | IEarnings,
  theme: Theme
) {
  switch (badgeType) {
    case ChartEventBadgeType.Split:
      return <ChartEventSplitPopoverContent badgeType={badgeType} rawData={data as ISplit} theme={theme} />
    case ChartEventBadgeType.Dividends:
      return <ChartEventDividendsPopoverContent badgeType={badgeType} rawData={data as IDividends} theme={theme} />
    case ChartEventBadgeType.EarningsPositive:
    case ChartEventBadgeType.EarningsNegative:
    case ChartEventBadgeType.EarningsFuture:
    case ChartEventBadgeType.EarningsNeutral:
      return <ChartEventEarningsPopoverContent badgeType={badgeType} rawData={data as IEarnings} theme={theme} />
    default:
      return null
  }
}

export function ChartEventPopover({ id, popoverState, badgeType, data, theme }: INoteDialog) {
  return (
    <ZIndexContext.Provider value="z-dialog">
      <Popover
        id={id}
        tabIndex={0}
        hasBackdrop={false}
        aria-label="Chart Settings"
        className={classNames('relative z-10 mt-10 flex max-h-full max-w-full flex-col', {
          'min-h-48': [
            ChartEventBadgeType.EarningsNeutral,
            ChartEventBadgeType.EarningsFuture,
            ChartEventBadgeType.EarningsNegative,
            ChartEventBadgeType.EarningsPositive,
          ].includes(badgeType),
          'min-h-28': badgeType === ChartEventBadgeType.Dividends,
          'min-h-20': badgeType === ChartEventBadgeType.Split,
        })}
        state={popoverState}
        focusOnHide={false}
        focusOnShow={false}
        hideOnClickOutside={false}
        hasViewportHeightLimit
        data-testid="chart-event-popover"
      >
        <DialogBody className="select-text">{getChartEventContentComponent(badgeType, data, theme)}</DialogBody>
      </Popover>
    </ZIndexContext.Provider>
  )
}
